import styled from "styled-components";

import iconCpp from "../../../assets/icons/icon-cpp.png";

const BulkCloneHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  width: 220px;
  height: 56px;
  margin-right: 0px;
  border-radius: 4px;
  align-self: start;
  overflow: auto;
  .icon {
    width: 40px;
    height: 40px;
    float: left;
  }
  .header {
    white-space: nowrap;
    overflow: hidden;
    color: var(--primary-text-color);
    line-height: 20px;
    font-weight: 600;
    float: left;
    font-size: 14px;
    font-family: inherit;
  }
  .desc {
    color: var(--primary-text-color);
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
  }
`;

export default function ProgressIndicatorHeader() {
  return (
    <BulkCloneHeaderIcon>
      <img src={iconCpp} alt="Pineapple" width="170" height="170" className="icon" />
      <div style={{ margin: "8px" }}>
        <span className="header">Clone Plus - Copy Items</span>
      </div>
    </BulkCloneHeaderIcon>
  );
}
